"use strict";
import Manager from "./glidejs/Manager";
$("[data-proposals-slider]").each((_i, elem) => {
  const id = elem.dataset.proposalsSlider;
  const $block = $(elem);
  const $proposalsSlider = $(`#proposals-slider-${id}`);
  const $proposalsGlideItems = $(`#proposals-glide-items-${id}`);
  const $filterForm = $(`#filters-form-${id}`);
  const slider = new Manager($proposalsSlider, $proposalsGlideItems, $block.find(".glide__bullets"), $filterForm, id);
  slider.start();
  $filterForm.on("change", (event) => {
    slider.start();
    $.get(slider.FilterUrl()).done((res) => {
      const div = document.createElement("div");
      const filtersContainer = slider.$formFilter.find("[data-filters-container]");
      div.innerHTML = res;
      const filtersContainerReplacement = div.querySelector("[data-filters-container]");
      filtersContainer.replaceWith(filtersContainerReplacement);
      const viewAllUrlConfig = div.querySelector("input[data-view-all-url-config]").dataset.viewAllUrlConfig;
      if (viewAllUrlConfig !== void 0) {
        const viewAllLink = document.querySelector(`[data-proposals-slider='${slider.sliderId}'] [data-view-all-link]`);
        if (viewAllLink) {
          viewAllLink.setAttribute("href", viewAllUrlConfig);
        }
      }
      div.remove();
    });
  });
});
